import { type PropsWithChildren } from 'react';

import { createSafeContext } from '@/util';

import type {
  VTableContextProps,
  VTableContextValue,
  VTableData,
} from './type';

export const VTableContext = createSafeContext<VTableContextValue<any>>();

export const VTableContextProvider = <T extends VTableData>({
  children,
  ...rest
}: PropsWithChildren<VTableContextProps<T>>) => {
  return (
    <VTableContext.Provider
      value={{
        ...rest,
      }}
    >
      {children}
    </VTableContext.Provider>
  );
};
